<template>
  <div class="content" style="max-width: 1300px !important"  @click="onClick()">
    <div v-if="!isReady">
      <i class="fa-solid fa-spinner fa-spin-pulse"></i> Loading...
    </div>
    <div v-else>
      <div class="row detail-row-sub-cards-title my-2">
        {{ title }}
      </div>
      <div class="row">
        <div style="display:flex; flex-wrap:wrap; align-items:stretch" v-for="(card, index) in cards" v-bind:key=index :class="card.col ? card.col : 'col-3'">
            <div class="hrtcard hrtcard--small shadow my-2 mx-1">
                <div class="text-primary">
                    {{ card["title"] }}
                </div>
                <div class="text-body">
                    <div v-if="card['items'] && card['items'].length > 6" class="split-columns">
                        <div v-for="(item, itemIndex) in card['items']" :key="itemIndex" class="item">
                            <div class="d-flex"><b class="text-voice-title">{{ item['label'] + ': &#32;' }}</b> <span class="ml-1" v-html="item.value"></span></div>                         
                        </div>
                    </div>
                    <div v-else class="split-columns">
                        <div v-for="(item, itemIndex) in card['items']" :key="itemIndex" class="item">
                            <div class="d-flex"><b class="text-voice-title">{{ item['label'] + ': &#32;' }}</b> <span class="ml-1" v-html="item.value"></span></div>                         
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>        
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log("qui");
    this.getRowData();
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
    fake_first_column: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      isReady: false,
      cards: [],
      title: ""
    };
  },
  methods: {
    handleAction(buttonData, rowData) {
      switch (buttonData.actionType) {
        case "sidebar":
          this.actionSidebar(buttonData, rowData);
          break;
        case "popup":
          this.actionPopup(buttonData, rowData);
          break;
        case "delete":
          this.actionDelete(buttonData, rowData);
          break;
      }
      //maybe coming soon the others action
    },
    getRowData() {
      //call axios for datas
      axios
        .get(this.rowData.detailRowUrl)
        .then((response) => {            
            this.cards = response.data.cards;
            this.title = response.data.title;
            this.isReady = true;            
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    onClick(event) {},
    croptText(text, len) {
      if (text) {
        if (text.length > len) {
          return text.substring(0, len) + "...";
        } else {
          return text;
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
  .detail-row-sub-cards-title{
    color: #1767A2 !important;
    font-size: 16px;
    font-weight: bold;
    margin-left: 15px;    
  }  .split-columns {
    display: flex;
    flex-wrap: wrap;
  }
  .item {
    flex-basis: 50%;
    padding: 2px;
  }

  .hrtcard--small {
    min-width:300px;
    overflow-x:auto;
  }
</style>